import { useEffect, useState } from 'react';
import Base from '../utils/base'

export default function ErrorQRModal(){
    var base = new Base()

    return(
        <>
        <div className="modal fade" id="modalErrorQR" tabIndex="-1" aria-labelledby="modalErrorQRLabel" aria-hidden="true">
                <div className="modal-dialog p-4 pt-5 mt-5">
                    <div className="modal-content border-0 shadow-sm" style={{borderRadius : '.75rem'}}>
                        <div className="modal-body">
                            <div className={'row'}>
                                <div className='col-12'>
                                    <div className='row'>
                                        <div className='col-12 px-5'>
                                            <p className='m-0 text-center' style={{fontSize : '1.25rem'}}><b className='text-danger'>Wrong QR Code</b><br />Please Retry Scanning <b className='text-primary'>Product's</b> QR Code</p>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <img src={base.img_scan_qr} style={{height : '12rem'}} />
                                        </div>
                                        <div className='col-12 mt-3 text-center'>
                                            <button type='button' className='btn btn-lg btn-primary rounded w-100' data-dismiss="modal">OK</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}